import React from 'react'
import { Link } from 'react-router-dom'
import withCategoriesData from '../../../Desktop/Pages/LandingPage/HOcs/withCategoriesData'

const MobileCategories = ({ categories }) => {
	return (
		<div>
			<div className='mt-0 pt-1 me-2'>
				<div className='d-flex justify-content-lg-start ms-1 overflow-scroll'>
					{categories.map((category) => (
						<Link
							key={category._id}
							to={category.categoryTypeName === 'Game' ? `/MobileProductList` : `/ProductListingCategories/${category._id}`}
							className='text-decoration-none'
						>
							<div className='d-flex flex-column align-items-center ms-2'>
								<div>
									<div className='text-center rounded-circle'>
										<img
											alt={category.categoryName}
											src={`${process.env.REACT_APP_RESOURCE_URL}${category.imageUrl}`}
											className='avatar categories-img-product-mobile-icon img-product'
										/>
									</div>
									<div className='lh-1 text-center text-wrap'>
										<span className='text-black text-xxs'>
											<small className='fw-bolder text-nowrap '>{category.categoryName}</small>
										</span>
									</div>
								</div>
							</div>
						</Link>
					))}
				</div>
			</div>
		</div>
	)
}

export default withCategoriesData(MobileCategories)
